import safeLocalStorage from 'safe-localstorage';

export function setLoading(state, loading) {
  state.loading = loading;
}

export function setSubscriptions(state, subscriptions) {
  state.subscriptions = subscriptions;
  safeLocalStorage.set('subscriptions/estimatedSubCount', subscriptions.length);
}

export function setSubUpdateError(state, error) {
  state.subUpdateError = error;
}

export function setPlansLoading(state, loading) {
  state.plansLoading = loading;
}

export function setPlans(state, plans) {
  state.plans = plans;
}

export function subscriptionsLoaded(state) {
  state.subscriptionsLoaded = true;
}

export function updateSubscriptionById(state, { id, subscription }) {
  const subscriptions = [];

  state.subscriptions.forEach((existingSubscription) => {
    if (existingSubscription.id === id) {
      subscriptions.push({ ...subscription });
    } else {
      subscriptions.push({ ...existingSubscription });
    }
  });

  state.subscriptions = subscriptions;
}
